/**
 * CrewFilters Component
 * Filter controls for crew list - Compliance dropdown + Bulk Actions
 * Note: Status dropdown removed (redundant with FilterTabs) per Advisor approval 2026-03-04
 */

import React from 'react';
import Dropdown from '../../../../common/Dropdown';

const CrewFilters = ({
  complianceFilter,
  onComplianceFilterChange,
  showBulkActions,
  onToggleBulkActions,
  selectedCount = 0
}) => {
  return (
    <div className="flex items-center justify-between gap-4">
      {/* Left side - Compliance Dropdown only (Status handled by FilterTabs) */}
      <div className="flex gap-3">
        <Dropdown
          value={complianceFilter}
          onChange={onComplianceFilterChange}
          width="w-auto min-w-[160px]"
          options={[
            { value: 'all', label: 'All Compliance' },
            { value: 'compliant', label: 'Compliant' },
            { value: 'issues', label: 'Issues' }
          ]}
        />
      </div>

      {/* Right side - Bulk Actions Toggle */}
      {/* FT-16: min-h-[44px] ensures 44px+ touch targets on mobile */}
      <button
        onClick={onToggleBulkActions}
        className={`px-4 py-3 md:py-1.5 text-base md:text-sm font-medium rounded-md border transition-colors min-h-[44px] ${
          showBulkActions
            ? 'bg-cyan-100 text-cyan-700 border-cyan-300'
            : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
        }`}
      >
        {showBulkActions ? `Selected (${selectedCount})` : 'Bulk Actions'}
      </button>
    </div>
  );
};

export default CrewFilters;
